import CreateUpdate from './CreateUpdate';
import List from './List';
import ModalForm from './ModalForm';

export default { CreateUpdate, List, ModalForm };
